import './DeleteAccountModal.scss';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { useConfiguration } from 'common/hooks/useConfiguration';
import { observer } from 'mobx-react-lite';
import { ReactElement, SyntheticEvent } from 'react';
import { ButtonWithLoader } from '../../../../design/buttons/ButtonWithLoader';
import { S_Modal } from '../../../../design/modals/modal/S_Modal';
import { EncryptedWarning } from '../../../../modules/decryption/EncryptedWarning';

interface IProps {
  showDeleteAccountModal: boolean;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

export const DeleteAccountModal = observer((props: IProps): ReactElement => {
  const configuration = useConfiguration();

  const { t } = useTranslator();

  const handleSubmit = async (e: SyntheticEvent): Promise<void> => {
    e.preventDefault();
    await props.onConfirm();
  };

  return (
    <S_Modal
      isOpen={props.showDeleteAccountModal}
      toggle={props.onCancel}
      headerText={t('delete_account')}
      buttons={
        <>
          <Button
            id='cancel-delete'
            variant='outlined'
            onClick={props.onCancel}
          >
            {t('no')}, {t('keep_account')}
          </Button>
          <ButtonWithLoader
            id='confirm-delete'
            loaderKey='confirm-delete'
            onClick={handleSubmit}
          >
            {t('yes')}, {t('delete_account_and_logout')}
          </ButtonWithLoader>
        </>
      }
    >
      <div className='delete-account-modal-body'>
        <div className='alerts'>
          <EncryptedWarning text={`${t('warning')}:`} /> {t('this_cannot_be_undone')}
        </div>
        <ul className='delete-consequences'>
          <li>{t('all_shared_project_with_your_team_will_be_inaccessible')},</li>
          <li>{t('all_work_made_statistics_and_history_will_be_deleted')},</li>
          <li>{t('all_configured_projects_will_be_deleted')},</li>
          <li>{t('all_datasets_and_images_will_be_deleted_as_well')}.</li>
        </ul>
        <div>
          {t('all_your_data_will_be_deleted_in_next')}
          {configuration.appConfig.userAccountDeletionDelayDayCount}
          {t('days')}.&nbsp;
          {t('if_you_are_not_sure_about_deletion_please_follow_instructions_in_email_we_will_send_you_after_delete')}
        </div>
        <div className='alerts'>
          <div>{t('are_you_sure_to_delete_your_account')}</div>
        </div>
      </div>
    </S_Modal>
  );
});
